import React from "react"
import { bindActionCreators } from "redux"
import { withRouter } from "react-router-dom"
import { connect } from "react-redux"
import { DefaultButton, PrimaryButton } from "../../components"
import styled from "styled-components"

import * as actions from "./irr-sample.actions"
import * as selectors from "./irr-sample.selectors"
import * as applicationActions from "../../application.actions"
import * as applicationSelectors from "../../application.selectors"
import * as periodActions from "../periods/period.actions"

import IrrSampleInfo from "./components/IrrSampleInfo"
import IrrSampleGrid from "./components/IrrSampleGrid"

const Container = styled.div``

class IrrSample extends React.Component {
  state = {
    show: false,
  }

  componentDidMount() {
    const {
      actions: { fetchIrrSample, setPageTitle },
      match: {
        params: { sampleId },
      },
    } = this.props

    fetchIrrSample(sampleId)
    setPageTitle("Interrater Reliability Monitoring (IRR)")
  }

  componentWillUnmount() {
    this.props.actions.clearIrrSample()
  }

  render() {
    const {
      irrSample,
      reviewers,
      MQDs,
      actions,
      irrSampleGridData,
      history,
      irrType,
      busy
    } = this.props

    return (
      <Container>
          <div className="row">
            <div className="col-sm-12">
              <PrimaryButton onClick={() => history.push("/irr")}>
                Back
              </PrimaryButton>
            </div>
          </div>
          <div style={{display: !busy ? 'block' : 'none' }}>
             <IrrSampleInfo
              reviewers={irrType.hsag ? reviewers : MQDs}
              irrSample={irrSample}
              reassignReviewer={actions.reassignReviewer}
            />
          </div>
         
          {!busy && <IrrSampleGrid data={irrSampleGridData} type={irrType} />    }  
      </Container>
    )
  }
}

export default withRouter(
  connect(
    (state) => ({
      roles: applicationSelectors.irrRoles(state),
      reviewers: applicationSelectors.reviewers(state),
      MQDs: applicationSelectors.MQDs(state),
      fetching: state.irrs.fetching,
      irrSample: selectors.irrSample(state),
      irrSampleGridData: selectors.irrSampleGridData(state),
      irrType: selectors.irrType(state),
      busy: applicationSelectors.fetchingData(state)
    }),
    (dispatch) => ({
      actions: bindActionCreators(
        {
          ...applicationActions,
          ...actions,
          ...periodActions,
        },
        dispatch
      ),
    })
  )(IrrSample)
)



// WEBPACK FOOTER //
// ./src/modules/irr-sample/index.js